const initialState = {
  selectedToken: null,
  selectedUnitId: null, // Выбранный отряд, размещенный на поле
  selectedFarmHexKey: null, // Выбранная ферма для распределения снабжения
  isFarmAutoSelected: false, // Ферму выделила панель снабжения, а не игрок
  // Раздача (раунд и игрок), в которой игрок отказался от автовыбора фермы
  supplyAutoFarmDeclinedTurn: null,
  // Казарма, выбранная первой (до типа отряда) на этапе найма
  selectedBarracksHexKey: null,
  destructionToolActive: false, // Активен ли инструмент уничтожения жетонов
  // Ячейка, выбранная для просмотра информации в футере во время чужого хода
  // (см. handleInspectionClick в GameScene) — чисто клиентский выбор
  inspectedHexKey: null,
  // Режим способности Гоблинов, выбранный в тулбаре этапа способностей:
  // 'SET_TRAP' | 'REMOVE_TRAP' | 'DAMAGE_BUILDING' | null — чисто клиентский
  // выбор, определяет, какая из трёх calculateAvailable*Cells используется
  // для подсветки целей и обработки клика (см. add-goblins-faction design.md)
  goblinsAbilityMode: null,
};

const selectedEntitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_UNIT': {
      return {
        ...state,
        selectedUnitId: action.payload.unitId,
        // Смена выбранного отряда сбрасывает режим способности Гоблинов —
        // режим предыдущего юнита не должен переноситься на другой отряд
        goblinsAbilityMode: null,
      };
    }

    case 'DESELECT_UNIT': {
      return {
        ...state,
        selectedUnitId: null,
        goblinsAbilityMode: null,
      };
    }

    case 'SET_GOBLINS_ABILITY_MODE': {
      return {
        ...state,
        goblinsAbilityMode: action.payload.mode,
      };
    }

    // inspectedHexKey здесь НЕ сбрасывается: COMPLETE_PHASE летит при каждой
    // смене ходящего игрока, а выбор ячейки должен переживать чужие ходы —
    // он сбрасывается только при наступлении хода пользователя (эффект в
    // Footer.js) или кликом-деселектом
    case 'COMPLETE_PHASE': {
      return {
        ...state,
        selectedToken: null,
        selectedUnitId: null,
        selectedFarmHexKey: null,
        isFarmAutoSelected: false,
        selectedBarracksHexKey: null,
        goblinsAbilityMode: null,
      }
    }

    // Этап найма закончился — выбранная под найм казарма больше не актуальна
    case 'SET_WAR_PHASE_STAGE': {
      return {
        ...state,
        selectedBarracksHexKey: null,
      };
    }

    case 'SELECT_BARRACKS_FOR_RECRUITMENT': {
      return {
        ...state,
        selectedBarracksHexKey: action.payload.barracksHexKey,
      };
    }

    case 'DESELECT_BARRACKS_FOR_RECRUITMENT': {
      return {
        ...state,
        selectedBarracksHexKey: null,
      };
    }

    case 'SET_INSPECTED_HEX': {
      return {
        ...state,
        inspectedHexKey: action.payload.hexKey,
      };
    }

    case 'CLEAR_INSPECTED_HEX': {
      return {
        ...state,
        inspectedHexKey: null,
      };
    }

    case 'UNDO_PENDING_RECRUITMENT_ACTION': {
      const selectedUnitId = state.selectedUnitId;
      const lastRecruitmentAction = action.payload.lastRecruitmentAction;

      const {unitId, actionType} = lastRecruitmentAction;

      if (actionType === 'UNIT_RECRUITMENT' && selectedUnitId === unitId) {
        return {
          ...state,
          selectedUnitId: null,
        }
      }

      return state;
    }

    // === Supply system ===
    case 'SELECT_FARM': {
      const isAuto = Boolean(action.payload.isAuto);
      return {
        ...state,
        selectedFarmHexKey: action.payload.farmHexKey,
        isFarmAutoSelected: isAuto,
        // Сам выбрал ферму — вернулся к раздаче: следующую снова можно выделять за него
        supplyAutoFarmDeclinedTurn: isAuto ? state.supplyAutoFarmDeclinedTurn : null,
      };
    }

    case 'DESELECT_FARM': {
      return {
        ...state,
        selectedFarmHexKey: null,
        isFarmAutoSelected: false,
      };
    }

    case 'DECLINE_SUPPLY_AUTO_FARM': {
      return {
        ...state,
        supplyAutoFarmDeclinedTurn: action.payload.turnKey,
        // Выбор игрока отказ не трогает, а автоматический снимает
        selectedFarmHexKey: state.isFarmAutoSelected ? null : state.selectedFarmHexKey,
        isFarmAutoSelected: false,
      };
    }

    case 'SET_SELECTED_TOKEN':
      return {
        ...state,
        selectedToken: action.payload,
      };

    case 'TOGGLE_DESTRUCTION_TOOL':
      return {
        ...state,
        destructionToolActive: !state.destructionToolActive,
        selectedToken: state.destructionToolActive ? state.selectedToken : null, // Сбрасываем selectedToken при активации      };
      }

    default:
      return state;
  }
};

export default selectedEntitiesReducer;
